import {Box} from "@mui/material";

// updated
export default function DialogContainer(props: { children: JSX.Element[] | JSX.Element, preferredWith?: number, bgcolor?: string }) {
    return <Box sx={{width: {xs: '100%', md: props.preferredWith || '350px'}, height: '100%', bgcolor: props.bgcolor ?? 'background.paper'}}>
        {
            props.children
        }
    </Box>

}
